import React from "react";
import ObjectLoader from "../common/ObjectLoader";
interface Props {
  children: React.ReactNode;
  className?: string;
  isLoading?: boolean;
}
export default function ContentLayout({
  children,
  className = " p-5 sm:p-7 ",
  isLoading,
}: Props) {
  if (isLoading) {
    return (
      <div className="w-full min-h-[60vh] bg-white rounded-3xl border border-app-line shadow-card p-7 flex items-center justify-center ">
        <ObjectLoader />
      </div>
    );
  }
  return (
    <div className={"w-full bg-white rounded-3xl border border-app-line shadow-card " + className}>
      {children}
    </div>
  );
}
